'use strict';

var config = [

    {

        route: '/most-innovative-companies$',

        method: ['GET'],

        controller: 'renderMICIndex',

        view: {
            route: 'most-innovative-companies',
            alias: 'mic-index',
            file: 'js/mic-index.js'
        },

        timeout: 2000

    }

];

exports.config = config;
